/* tslint:disable */
/* eslint-disable */
import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { GetPreviousPaymentsQuery } from '../../models/get-previous-payments-query';
import { GetPreviousPaymentsQueryResult } from '../../models/get-previous-payments-query-result';

export interface ApiProjectFinancialSummariesGetPreviousPaymentsPost$Plain$Params {
      body?: GetPreviousPaymentsQuery
}

export function apiProjectFinancialSummariesGetPreviousPaymentsPost$Plain(http: HttpClient, rootUrl: string, params?: ApiProjectFinancialSummariesGetPreviousPaymentsPost$Plain$Params, context?: HttpContext): Observable<StrictHttpResponse<GetPreviousPaymentsQueryResult>> {
  const rb = new RequestBuilder(rootUrl, apiProjectFinancialSummariesGetPreviousPaymentsPost$Plain.PATH, 'post');
  if (params) {
    rb.body(params.body, 'application/*+json');
  }

  return http.request(
    rb.build({ responseType: 'text', accept: 'text/plain', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<GetPreviousPaymentsQueryResult>;
    })
  );
}

apiProjectFinancialSummariesGetPreviousPaymentsPost$Plain.PATH = '/api/ProjectFinancialSummaries/GetPreviousPayments';
